<div class="col-12">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Events Page</h5>
      <p class="card-text">Below is a full list of our year's events. Past events will be greyed out.</p>
    </div>
  </div>
  <div class="col-12" *ngFor="let event of upcomingEvents">
    <app-event [event]="event"></app-event>
  </div>
</div>
